export const ROLE = {
    USER: 0,
    ADMIN: 1,

    DRIVING: {
        ADMIN: 10,
        TEACHER: 12,
        STUDENT: 11,
        REPORTER: 13,
        DAT_ADMIN: 15,
        // DAT_TEACHER (16) — dat.uniapp.vn-only TeacherGuard access.
        // Cố tình KHÔNG add vào uniapp-frontend role.js hay uniapp-backend
        // roles.js: account chỉ có role này sẽ:
        //   - đăng nhập + dùng được TeacherGuard pages (/, /a1a, /search, /cabin)
        //   - bị reject ở uniapp-frontend AdminDrivingGuard (driving/admin/*)
        //   - bị reject ở driving-dat AdminGuard / AdminDrivingGuard
        //     (MeInvoice, /admin/session ... — không có 16 trong allow list)
        // Dùng cho giáo viên thuần xem dat, không can thiệp admin.
        DAT_TEACHER: 16,
        // DAT_APPROVER (17) — quyền duyệt kết quả DAT lên GetFly
        // (POST /v2/dat/approve-result). Gán KÈM DAT_ADMIN: role [15, 17].
        // BE guard requireDatApprover chỉ cho [1, 10, 17] — DAT_ADMIN
        // thường (15) bị 403. Sync với uniapp-backend roles.js.
        DAT_APPROVER: 17,
    },

    ELEARNING: {
        ADMIN: 20,
        TEACHER: 21,
        STUDENT: 22,
    },

    UNIFORM: {
        ADMIN: 30,
    },

    REAL_ESTATE: {
        ADMIN: 40,
    },

    STORE: {
        ADMIN: 50,
    },
}
